<template>
  <div class="container-fluid">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    >
      <template #cell(pay_birthday)="row">
        {{ convertRocDate(row.item.pay_birthday) }}
      </template>
    </tables-page>

  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import toHelpingOthersApi from "@/models/API/toHelpingOthersApi";
import { convertRocDate, getLocalUserInfo } from "@/models/HELPERS/common.js";

export default {
  name: 'business',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '資料管理', url: '', isActive: true },
          { name: '要助人資料', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        name: '',
      },
      status: {
        isNew: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "pay_name",
            label: "要助人姓名",
          },
          {
            key: "pay_birthday",
            label: "要助人生日",
          },
          {
            key: "pay_cellphone",
            label: "要助人手機",
          },
          {
            key: "automatic_debit_contract",
            label: "自動扣款契約",
          }
        ],
        info: {}
      }
    }
  },
  mounted() {
    this.toHelpingOthersApi = new toHelpingOthersApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getHelpingPersonalInfo();
    },
    convertRocDate,
    // 查詢要助人個人資訊
    getHelpingPersonalInfo(pageIndex = null) {
      const params = {
        'pay_ID_number': this.data.info.account,
        'PageSize': 1,
        'PageIndex': 1,
      };
      this.toHelpingOthersApi.getHelpingPersonalInfo((response) => {
        const res = response.data;

        this.data.table_data = res.data;
      }, params)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/toHelpingOthers/information.vue